<template>
    <div
        class="compare-well-component mx-2"
        :class="{ focused: isHovered }"
        @mouseenter="setHoveredWellId"
        @mouseleave="resetHoveredWellId"
    >
        <well-card :master="well && index === 0" :well="well" size="large" />

        <well-mk-blast-panel
            v-if="!isFdaFriendly"
            class="w-100 mt-2"
            :current-event="currentEvent"
            :well="well"
        />
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import WellCard from './WellCard'
import WellMkBlastPanel from './WellMkBlastPanel'

export default {
    name: 'CompareWellComponent',
    components: {
        WellMkBlastPanel,
        WellCard
    },
    props: {
        well: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    computed: {
        ...mapState({
            hoveredWellId: state => state.timelapse.hoveredWellId,
            videoSeekMode: state => state.video.videoSeekMode,
            currentRunIndex: state => state.video.currentRunIndex,
            selectedMKEventSN: state => state.video.selectedMKEventSN
        }),
        ...mapGetters({
            isFdaFriendly: 'common/isFdaFriendly'
        }),
        currentEvent() {
            if (this.videoSeekMode === 'time') {
                const currentRun = this.well.runs[this.currentRunIndex]
                return currentRun ? currentRun.mkEvent : null
            } else {
                return this.well.inferenceData.morphokinetics.find(mkEvent => {
                    return (
                        this.selectedMKEventSN &&
                        mkEvent.systemName.toLowerCase() === this.selectedMKEventSN.toLowerCase()
                    )
                })
            }
        },
        isHovered() {
            return this.hoveredWellId === this.well._id
        }
    },
    methods: {
        setHoveredWellId() {
            this.$store.state.timelapse.hoveredWellId = this.well._id
        },
        resetHoveredWellId() {
            this.$store.state.timelapse.hoveredWellId = null
        },
        selectForComparison(well) {
            const isSelected = this.selectedForComparison.includes(well._id)
            this.$store.dispatch('timelapse/addRemoveFromWellComparison', {
                wellId: well._id,
                add: !isSelected
            })
        }
    }
}
</script>

<style lang="scss">
.compare-well-component {
    // position: relative;
    width: $well-compare-cards-width;
    transition: all 0.2s;
    background-color: $dark-3;
    border-radius: $border-radius-sm;

    @media screen and #{$new-break4open} {
        &:hover {
            background-color: $dark-2;
            box-shadow: 0 0 1rem $shadow;
        }
    }

    @media screen and #{$new-break3open} {
        .well-card {
            box-shadow: none !important;
            position: sticky;
            top: 0;
            z-index: 1;
            background-color: $dark-3;

            &:has(.scaled) {
                z-index: 9;
            }
        }
    }
}
</style>
